import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { sendHoverSoundCommand } from 'react-wot-bootstrap'

import Back from './components/Back/Back'
import Front from './components/Front/Front'
import EnterClan from './components/EnterClan/EnterClan'
import { useMetricsLogTimeSpent, useMetricsLog } from 'helpers/uilogging/hooks'
import { Actions, FEATURE, Items } from 'containers/Landing/logConstants'
import { RecommendedClanPropTypes } from '../../../../propTypes'

import styles from './Card.scss'

export const Card = ({ clan, partnerID, dwhType, total, membersCount, listType, languages, clanNumber }) => {
    const log = useMetricsLog(FEATURE)
    const [start, stop] = useMetricsLogTimeSpent(FEATURE)

    const handleMouseEnter = useCallback(() => {
        start(Actions.Hover)
        sendHoverSoundCommand()
    }, [start])

    const handleMouseLeave = useCallback(() => {
        stop({
            action: Actions.Hover,
            item: Items.ClanInfoCard,
            timeLimit: 1.0,
            parentScreen: Items.LandingClans,
            partnerID: partnerID,
            info: JSON.stringify({
                type: dwhType,
                total: total,
                membersCount: membersCount,
                gameLevel: listType,
                languages: languages,
                clanNumber: clanNumber,
                clanId: clan.id,
            }),
        })
    }, [stop])
    const handleButtonClick = useCallback(() => {
        log({
            action: Actions.Click,
            item: Items.JoinClanButton,
            parentScreen: Items.LandingClans,
            partnerID: partnerID,
            info: JSON.stringify({
                type: dwhType,
                total: total,
                membersCount: membersCount,
                gameLevel: listType,
                languages: languages,
                clanNumber: clanNumber,
                clanId: clan.id,
            }),
        })
    }, [log])
    const { dwhClanReservesScore, dwhSquadScore, dwhGlobalMapScore, dwhStrongholdScore, description } = clan
    const isSimple = [dwhClanReservesScore, dwhSquadScore, dwhGlobalMapScore, dwhStrongholdScore].includes(undefined)

    return (
        <div className={styles.base} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            <div className={styles.flipWrapper}>
                <div className={styles.front}>
                    <Front clan={clan} isSimple={isSimple} />
                </div>
                <div className={styles.back}>
                    <Back description={description} clanNumber={clanNumber} clan={clan}>
                        <EnterClan onClickButton={handleButtonClick} clan={clan} />
                    </Back>
                </div>
            </div>
        </div>
    )
}

Card.propTypes = {
    clan: RecommendedClanPropTypes,
    partnerID: PropTypes.string.isRequired,
    dwhType: PropTypes.string,
    total: PropTypes.number,
    membersCount: PropTypes.number,
    listType: PropTypes.string,
    languages: PropTypes.array,
    clanNumber: PropTypes.number,
}

export default Card



// WEBPACK FOOTER //
// ./containers/Landing/components/LandingClans/components/Card/Card.jsx